module.exports = __webpack_public_path__ + "assets/img/zyrw05.b91b9d92.png";